const DEV_URL = 'https://to1i7hikzd.execute-api.ap-northeast-1.amazonaws.com/default/'
const ST_URL = 'https://to1i7hikzd.execute-api.ap-northeast-1.amazonaws.com/default/'
const PRD_URL = 'https://v4l1r7ah1j.execute-api.ap-northeast-1.amazonaws.com/default/'

const DEV_AWS_USER_POOLS_ID = 'ap-northeast-1_AgekSaVWt'
const ST_AWS_USER_POOLS_ID = 'ap-northeast-1_dGRckDhQ3'
const PRD_AWS_USER_POOLS_ID = 'ap-northeast-1_bwFvWPddH'
const URI_CHANGE_OPT_IN = 'change-opt-in'

function api_url(aws_user_pools_id) {
    if(aws_user_pools_id == PRD_AWS_USER_POOLS_ID) {
        return PRD_URL
    } else if(aws_user_pools_id == ST_AWS_USER_POOLS_ID) {
        return ST_URL
    } else if(aws_user_pools_id == DEV_AWS_USER_POOLS_ID) {
        return DEV_URL
    }
    return DEV_URL
}
function api_key(aws_user_pools_id) {
    if(aws_user_pools_id == PRD_AWS_USER_POOLS_ID) {
        return PRD_KEY
    } else if(aws_user_pools_id == ST_AWS_USER_POOLS_ID) {
        return ST_KEY
    } else if(aws_user_pools_id == DEV_AWS_USER_POOLS_ID) {
        return DEV_KEY
    }
    return DEV_KEY
}

function get_api_url(aws_user_pools_id) {
    return api_url(aws_user_pools_id) + URI_CHANGE_OPT_IN
}
function get_api_key(aws_user_pools_id) {
    return api_key(aws_user_pools_id)
}
export default {
    get_api_url,
    get_api_key,
};